export const paymentColumns = ({
    excludeUser
}) => {
    let columns = [
        {
            text: 'User Name',
            value: 'userName',
        },
        {
            text: 'Mobile',
            value: 'mobileNo',
        },
        {
            text: 'Email',
            value: 'email',
        },
        {
            text: 'Payment ID',
            value: 'paymentMqNo',
        },
        {
            text: 'Subscriber ID',
            value: 'accountNo',
        },
        {
            text: 'Amount',
            value: 'amount',
        },
        {
            text: 'Transaction ID',
            value: 'trancationId',
        },
        {
            text: 'OpEntity',
            value: 'opentity_CODE',
        },
        {
            text: 'Transaction Date',
            value: 'trancationDate',
        },
        {
            text: 'Status',
            value: 'status',
        }
    ];
    if(excludeUser) {
        columns = columns.filter(c => {
            const { text } = c;
            if (text.match(/user name/i) || text.match(/mobile/i) || text.match(/email/i))
                return false;
            return true;
        })
    }
    return columns;
};

export const addColumns = ({
    excludeUser,
    totalChargeFilter,
    ncfFilter,
    planTypeFilter,
    nameFilter,
}) => {
    let columns = [
        {
            text: 'PaymentId',
            value: 'paymentId',
        },
        {
            text: 'Account Number',
            value: 'accountNo',
        },
        {
            text: 'Plan Code',
            value: 'planCode',
        },
        {
            text: 'Amount',
            value: 'totalCharge',
            filter: totalChargeFilter,
        },
        {
            text: 'NCF Price',
            value: 'ncf',
            filter: ncfFilter,
        },
        {
            text: 'Mobile',
            value: 'mobile',
        },
        {
            text: 'Email',
            value: 'email',
        },
        {
            text: 'Plan Type',
            value: 'planType',
            filter: planTypeFilter,
        },
        {
            text: 'OpEntity',
            value: 'opentity_CODE',
        },
        {
            text: 'Plan Name',
            value: 'planName',
            filter: nameFilter,
        },
        {
            text: 'Status',
            value: 'status',
        },
        {
            text: 'Created On',
            value: 'transactionDate',
        }
    ];
    if(excludeUser) {
        columns = columns.filter(c => {
            const { text } = c;
            if (text.match(/user name/i) || text.match(/mobile/i) || text.match(/email/i))
                return false;
            return true;
        })
    }
    return columns;
}

export const userColumns = () => [
    {
        text: 'Account No',
        value: 'accountNo',
    },
    {
        text: 'Email',
        value: 'email',
    },
    {
        text: 'Name',
        value: 'userProfile.customer_NAME'
    },
    {
        text: 'Mobile',
        value: 'mobile',
    },
    {
        text: 'Serial No',
        value: 'serialNo',
    },
    {
        text: 'OTP verified',
        value: 'otpVerify',
    },
    {
        text: 'Serial No Type',
        value: 'serialNoType',
    },
    {
        text: 'Customer Type',
        value: 'dp'
    },
    {
        text: 'Op Entity',
        value: 'userProfile.opentity_CODE'
    },
    {
        text: 'District',
        value: 'userProfile.district_CODE'
    },
    {
        text: 'Balance',
        value: 'walletBalance'
    },
    {
        text: 'Date Time',
        value: 'userProfile.createdDate'
    }
]
export const serviceRequestsColumns = () => [
    {
        text: 'Category Name',
        value: 'categoryName',
      },
      {
        text: 'Sub Category Name',
        value: 'subCategoryName',
      },
      {
        text: 'Created By',
        value: 'createdBy',
      },
      {
        text: 'Mobile No',
        value: 'mobile',
      },
      {
        text: 'Account No',
        value: 'accountNo',
      },
      {
        text: 'Created On',
        value: 'createdDate',
      },
      {
        text: 'Status',
        value: 'status',
      },
      {
        text: 'Comments',
        value: 'comments',
      },
      {
        text: 'Actions',
        value: 'action',
      },
      
      
]

    export const quickpayColumns = ({
        excludeUser
    }) => {
        let columns = [
            {
                text: 'User Name',
                value: 'userName',
            },
            {
                text: 'Mobile',
                value: 'mobileNo',
            },
            {
                text: 'Email',
                value: 'email',
            },
            {
                text: 'Payment ID',
                value: 'paymentMqNo',
            },
            {
                text: 'Subscriber ID',
                value: 'user.accountNo',
            },
            {
                text: 'Amount',
                value: 'amount',
            },
            {
                text: 'Transaction ID',
                value: 'trancationId',
            },
            {
                text: 'CustomerId',
                value: 'customerId',
            },
            {
                text: 'Transaction Date',
                value: 'trancationDate',
            },
            {
                text: 'Status',
                value: 'status',
            }
        ];
        if(excludeUser) {
            columns = columns.filter(c => {
                const { text } = c;
                if (text.match(/user name/i) || text.match(/mobile/i) || text.match(/email/i))
                    return false;
                return true;
            })
        }
        return columns;
    };
    